import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pc_header = _resolveComponent("pc-header")
  const _component_mobile_header = _resolveComponent("mobile-header")

  return (_ctx.device.display !== 1)
    ? (_openBlock(), _createBlock(_component_pc_header, {
        key: 0,
        class: _ctx.$attrs.class,
        isOnLoby: _ctx.isOnLoby,
        title: _ctx.title,
        isMultiView: _ctx.isMultiView,
        goodRoadCount: _ctx.goodRoadCount,
        onShowSwitchTable: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('show-switch-table'))),
        onOnShowLimit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('on-show-limit'))),
        onOnShowSingleShow: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('on-show-single-show'))),
        onOnShowSetting: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('on-show-setting')))
      }, null, 8, ["class", "isOnLoby", "title", "isMultiView", "goodRoadCount"]))
    : (_openBlock(), _createBlock(_component_mobile_header, {
        key: 1,
        class: _ctx.$attrs.class,
        isOnLoby: _ctx.isOnLoby,
        title: _ctx.title,
        isMultiView: _ctx.isMultiView,
        goodRoadCount: _ctx.goodRoadCount
      }, null, 8, ["class", "isOnLoby", "title", "isMultiView", "goodRoadCount"]))
}